/**
 * Keep Horizon header in drawer (mobile) mode at all viewports.
 */
(function () {
  const ROOT_CLASS = 'bowie-header-always-drawer';
  const HEADER_SELECTOR = '#header-component';

  function enforceDrawer(header) {
    header.classList.add('bowie-header--always-drawer');
    header.dataset.menuStyle = 'drawer';
  }

  function init() {
    if (!document.documentElement.classList.contains(ROOT_CLASS)) return;

    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    enforceDrawer(header);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'data-menu-style' && header.dataset.menuStyle !== 'drawer') {
          header.dataset.menuStyle = 'drawer';
        }
      }
    }).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
